/**
 * Import Dependency
 */
import React, { Component } from 'react'
// import ReactSwiper from 'react-id-swiper'
// import { Popover, NavBar, Icon, Flex, Grid, Stepper } from 'antd-mobile'
// import math from 'lodash/math'
// import injectSheet from 'react-jss'
// import cx from 'classnames'
// import logo from '../assets/images/logo.png'

/**
 * Import Antd Mobile Design
 */

/**
 * Import Container
 */

/**
 * Declare Variable
 */

/**
 * Component
 */
class ItemOptionsTotalComponent extends Component {
  calculateBottomSheetItemTotal = () => {
    const {
      stashByOptionGroups,
    } = this.props

    return stashByOptionGroups.reduce((accu, item) => {
      return accu + item.options.reduce((accu, option) => {
        return accu + option.price * (option.quantity ? option.quantity : 1)
      }, 0)
    }, 0)
  }

  render () {
    const {
      // classes,
      stash,
      intl,
    } = this.props

    const _undeterminedPriceText = intl.formatMessage(
      { id: 'summary.undetermined.price' },
    )
    if (stash.priceUndetermined) {
      return _undeterminedPriceText
    }

    if (stash.price === undefined) {
      return '-'
    }

    return (
      <React.Fragment>
        {stash.price - stash.discount + this.calculateBottomSheetItemTotal()}
      </React.Fragment>
    )
  }
};

/**
 * Export
 */
export default ItemOptionsTotalComponent



// WEBPACK FOOTER //
// ./src/components/ItemOptionsTotal.js